type EnvLiteral =
  | "production"
  | "production_sandbox"
  | "staging"
  | "staging_sandbox"
  | "dev"
  | "local";

const grafferLgwanDomain = "graffer.bsninet.asp.lgwan.jp";

// exporting for test
export const lgwanHostMap = {
  local: "http://localhost:5100",
  dev: "",
  staging: `https://staging-lgwan-ttzk.${grafferLgwanDomain}`,
  staging_sandbox: `https://staging-lgwan-sandbox-ttzk.${grafferLgwanDomain}`,
  production: `https://ttzk.${grafferLgwanDomain}`,
  production_sandbox: `https://sandbox-ttzk.${grafferLgwanDomain}`,
};

// exporting for test
export class EnvConfig {
  private environment: EnvLiteral;

  matchEnv<R>(matcher: { [key in EnvLiteral]: () => R }): R {
    return matcher[this.environment]();
  }
  matchEnvValue<R>(matcher: { [key in EnvLiteral]: R }): R {
    return matcher[this.environment];
  }
  getLgwanHost = (): string => {
    return envConfig.matchEnvValue(lgwanHostMap);
  };
  constructor(env: string | undefined) {
    if (!env) {
      throw new Error(
        "required env variable REACT_APP_ENVIRONMENT not provided",
      );
    }
    if (
      env === "production" ||
      env === "production_sandbox" ||
      env === "staging" ||
      env === "staging_sandbox" ||
      env === "dev" ||
      env === "local"
    ) {
      this.environment = env;
      return;
    }
    throw new Error(`invalid env ${env}`);
  }
}

export const isLGWANURL = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.includes(grafferLgwanDomain);
  } catch (e) {
    return false;
  }
};

const envConfig = new EnvConfig(process.env.REACT_APP_ENVIRONMENT);
export default envConfig;
